export enum CONFIRMATION_TYPES {
  DELETE = 'DELETE',
  RESTORE = 'RESTORE',
  DISABLE = 'DISABLE',
  ENABLE = 'ENABLE',
  REMOVE = 'REMOVE',
  WARN = 'WARN',
  CUSTOM = 'CUSTOM',
}
